export default "__VITE_ASSET__Bi1aBn8y__"